import React, { useRef, useEffect, useState } from 'react';
import moment from 'moment';
import { getCurrentMoment, getSplitDuration } from '../../utils/matches';
import { strings } from '../../resources/strings';

const calculateSecondsLeftToStart = (matchStartDate) => {
  const now = getCurrentMoment();
  const startDate = moment(matchStartDate);
  const nowInSeconds = now.format('X');
  const startInSeconds = startDate.format('X');

  return Math.max(0, startInSeconds - nowInSeconds);
};

export function pad(number, length = 2, force = false) {
  if (!force && number === null) {
    return '';
  }
  const s = `00${Number(number)}`;
  return s.substr(s.length - length);
}

function CountDown({ startDate }) {
  const interval = useRef();

  const [secondsLeftToStart, setSecondsLeftToStart] = useState(
    calculateSecondsLeftToStart(startDate)
  );

  useEffect(() => {
    let lastSecondsLeftToStart = 0;
    interval.current = setInterval(() => {
      const updateSecondsLeftToStart = calculateSecondsLeftToStart(startDate);
      if (updateSecondsLeftToStart !== lastSecondsLeftToStart) {
        lastSecondsLeftToStart = updateSecondsLeftToStart;
        setSecondsLeftToStart(updateSecondsLeftToStart);
      }
    }, 100);
    return () => {
      clearInterval(interval.current);
    };
  }, [startDate]);

  const { days, hours, minutes, seconds } = getSplitDuration(
    secondsLeftToStart,
    startDate
  );

  if (days >= 6) {
    const suffix =
      days >= 2
        ? strings.match_details_scene.days
        : strings.match_details_scene.day;

    return (
      <>
        <p className="heading-h3 heading-md-h2">
          {days} {suffix}
        </p>
        <p className="heading-h6 mb-2">TILL MATCH!</p>
      </>
    );
  }

  if (days >= 1) {
    const suffix =
      days >= 2
        ? strings.match_details_scene.days
        : strings.match_details_scene.day;

    return (
      <>
        <p className="heading-h3 heading-md-h2">
          {strings.match_details_scene[days]} {suffix}
        </p>
        <p className="heading-h6 mb-2">TILL MATCH!</p>
      </>
    );
  }

  if (hours) {
    return (
      <p className="heading-h3 heading-md-h2">
        {`${pad(hours)}:${pad(minutes)}:${pad(seconds)}`}
      </p>
    );
  }

  if (minutes && seconds) {
    return (
      <p className="heading-h3 heading-md-h2">
        {`${pad(minutes, 2, true)}:${pad(seconds)}`}
      </p>
    );
  }

  return null;
}

export default CountDown;
